import {
  message,
  PageHeader,
  Spin,
  Select,
  Row,
  Col,
  Space,
  Tag,
  Switch,
  Typography,
  Tooltip,
} from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Form,
  FormItem,
  SelectItem,
  InputNumberItem,
  dineroDisabledMask,
  round2Decimals,
  ButtonItem,
  round6Decimals,
  DatePickerItem,
  InputItem,
  ModalItem,
  DisponibilidadInsumoModal,
} from "../../../../Components/Items";
import GeneralFormLayout from "../../../../Components/GeneralFormLayout";
import InfoCard from "../../../../Components/InfoCard";
import { BookOutlined, DownloadOutlined, FileExcelOutlined } from "@ant-design/icons";
import { descargarExcelDocumento } from "../../../../Components/DescargarDocumentosMasivo";
import { CarOutlined, EnvironmentOutlined, InfoCircleOutlined, UserOutlined, PhoneFilled} from "@ant-design/icons";
import FacturasOrdenDeCompra from "../FacturasOrdenDeCompra/FacturasOrdenDeCompra";
import RecepcionesOrdenDeCompra from "../RecepcionesOrdenDeCompra/RecepcionesOrdenDeCompra";
import MandarCorreoOrdenDeCompra from "../MandarCorreoOrdenDeCompra/MandarCorreoOrdenDeCompra";
import moment from "moment";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import ordenCompraPdf from "../../../../Pdf/ordenCompraPdf";
import separacionInsumosPdf from "../../../../Pdf/separacionInsumosPdf";
import ModalVerRequisicion from "../../Requisiciones/ModalVerRequisicion/ModalVerRequisicion";
import InsumoDetalleRow from "../../../../Components/InsumoDetalleRow";
import ModalPolizasDocumento from "../../../../Components/ModalPolizasDocumento";
import { PrinterOutlined } from "@ant-design/icons";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const { Option } = Select;

class VerOrdenDeCompra extends Component {
  formRef = React.createRef();
  state = {
    modalDisponibilidadVisible: false,
    insumoSeleccionadoDisponibilidad: { id: null, nombre: '' },
    descargandoExcel: false,
    modalCorreo: false,
    loading: false,
    objetoProveedores: null,
    todasProveedores: null,
    objetoProyectos: null,
    todasProyectos: null,
    objetoInsumos: (
      <Option disabled value={0} key={0}>
        Seleccione un proveedor primero
      </Option>
    ),
    todasInsumos: [],
    impuestos: [],
    total: 0,
    subtotal: 0,
    arrayImpuestos: [],
    arrayRetenciones: [],
    totalPagar: 0,
    estado: 0,
    totalPagado: 0,
    numeroOrdenDeCompra: "",
    serieOrdenCompra: null,
    estadoFactura: 0,
    modalFacturas: false,
    modalElegirTipoDeProveedor: false,
    modalElegirTipoDeProveedorId: null,
    modalElegirTipoDeProveedorNombre: null,
    id: this.props.location.state.id,
    requisicionNumero: null,
    requisicionesAdicionales: [],
    mostrarDetalles: true,
    verInsumosComoSistema: !!this.props.verComoSistemaOCPorDefecto,
    modalPolizas: false,
    // null = todavía no se consultó la orden. Se bloquea la descarga hasta saber.
    aprobada: null,
  };
  componentDidMount() {
    this.consultarTodo();
  }
  promisedSetState = (newState) =>
    new Promise((resolve) => this.setState(newState, resolve));

  abrirDisponibilidad = (insumoId, nombre, proyectoId) => {
    this.setState({ modalDisponibilidadVisible: true, insumoSeleccionadoDisponibilidad: { id: insumoId, nombre, proyectoId } });
  };

  cerrarDisponibilidad = () => {
    this.setState({ modalDisponibilidadVisible: false });
  };

  abrirModalCorreo() {
    this.setState({ modalCorreo: true });
  }

  cerrarModalCorreo() {
    this.setState({ modalCorreo: false });
  }

  async consultarTodo() {
    this.setState({ loading: true });
    await axios
      .post(
        "ordenesdecompra/datosOrden",
        { empresaId: this.props.empresaId, ordenId: this.state.id },
        { headers: this.props.headersToken }
      )
      .then(async (res) => {
        console.log(res.data)
        if (res.data.success === 2) {
          let newState = {
            datosOrdenDeCompra: res.data.orden,
            // `aprobada` ausente = orden vieja, cuenta como aprobada.
            aprobada: res.data.orden.aprobada !== false,
            total: res.data.orden.total,
            totalPagar: res.data.orden.totalPagar,
            totalPagado: res.data.orden.totalPagado,
            subtotal: res.data.orden.subtotal,
            estado: res.data.orden.estado,
            estadoFactura: res.data.orden.estadoFactura,
            arrayImpuestos: res.data.orden.arrayImpuestos,
            arrayRetenciones: res.data.orden.arrayRetenciones,
            numeroOrdenDeCompra: res.data.orden.numero,
            serieOrdenCompra: res.data.orden.serieOrdenCompra,
            todasProveedores: res.data.proveedores,
            requisicionNumero: res.data.requisicionNumero,
            objetoProveedores: res.data.proveedores.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.stringBuscar}
                </Option>
              );
            }),
            todasProyectos: res.data.proyectos,
            objetoProyectos: res.data.proyectos.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre}
                </Option>
              );
            }),
            todasInsumos: res.data.insumos,
            objetoInsumos: res.data.insumos.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre || value.descripcion}
                </Option>
              );
            }),
            todasMonedas: res.data.monedas,
            objetoMonedas: res.data.monedas.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre + " - " + value.abreviacion}
                </Option>
              );
            }),
            requisicionesAdicionales: res.data.requisicionesAdicionales,
          };

          this.setState(newState, () => {
            this.formRef.current.setFieldsValue({
              ...res.data.orden,
              fechaEntrega: res.data.orden.fechaEntrega ? moment(res.data.orden.fechaEntrega) : null,
              insumos: res.data.orden.insumos.map((value) => {
                let puConImpuestos = 0;
                if (value.cantidad && value.cantidad > 0) {
                  puConImpuestos = value.total / value.cantidad;
                }
                return {
                  ...value,
                  precioUnitarioConImpuestos: round2Decimals(puConImpuestos),
                };
              }),
            });
          });
        } else {
          message.error(
            "Error no se encontro informacion de la orden de compra"
          );
        }
      });
    this.setState({ loading: false });
  }
  atras() {
    this.props.history.goBack();
  }

  async onChangePrecioCantidadDescuento(value, key) {
    let arrayValue = await this.formRef.current.getFieldValue("insumos");
    let proveedorId = await this.formRef.current.getFieldValue("proveedorId");
    const insumo = this.state.todasInsumos.find(
      (valueInsumos) => valueInsumos._id === arrayValue[key]?.insumoId
    );
    if (!insumo) return;
    const precioUnitario = Number(arrayValue[key].precioUnitario);

    let totalImpuestosPrecioSinImpuestos = 0;
    insumo.impuestos.map((valueImpuesto) => {
      let totalImpuesto;
      if (valueImpuesto.tasaCuota === 1) {
        totalImpuesto = precioUnitario * (valueImpuesto.monto / 100);
      } else if (valueImpuesto.tasaCuota === 2) {
        totalImpuesto =
          (precioUnitario + totalImpuestosPrecioSinImpuestos) *
          (valueImpuesto.monto / 100);
      } else if (valueImpuesto.tasaCuota === 3) {
        totalImpuesto = valueImpuesto.monto;
      } else if (valueImpuesto.tasaCuota === 4) {
        let cantidad = arrayValue[key].cantidad;
        if (cantidad) {
          totalImpuesto =
            (arrayValue[key].impuestos || 0) / arrayValue[key].cantidad;
        }
      } else if (valueImpuesto.tasaCuota === 5) {
        totalImpuesto = 0;
      }
      totalImpuestosPrecioSinImpuestos += totalImpuesto;
      return null;
    });
    arrayValue[key].precioUnitarioConImpuestos = round2Decimals(
      precioUnitario + totalImpuestosPrecioSinImpuestos
    );
    const cantidad = arrayValue[key].cantidad;
    const descuento = arrayValue[key].descuento || 0;

    if ((precioUnitario || precioUnitario === 0) && cantidad && insumo) {
      //1
      const subtotal = round6Decimals(cantidad * precioUnitario);
      //2
      const totalDescuento = round6Decimals(subtotal * (descuento / 100));
      //3
      const totalEntrada = round6Decimals(subtotal - totalDescuento);
      arrayValue[key].subtotal = totalEntrada;

      let totalImpuestos = 0;
      let arrayImpuestos = insumo.impuestos.map(
        //4
        (valueImpuesto) => {
          let totalImpuesto;
          if (valueImpuesto.tasaCuota === 1) {
            totalImpuesto = round6Decimals(
              totalEntrada * (valueImpuesto.monto / 100)
            );
          } else if (valueImpuesto.tasaCuota === 2) {
            totalImpuesto = round6Decimals(
              (totalEntrada + totalImpuestos) * (valueImpuesto.monto / 100)
            );
          } else if (valueImpuesto.tasaCuota === 3) {
            totalImpuesto = round6Decimals(cantidad * valueImpuesto.monto);
          } else if (valueImpuesto.tasaCuota === 4) {
            totalImpuesto = round6Decimals(arrayValue[key].impuestos);
          } else if (valueImpuesto.tasaCuota === 5) {
            totalImpuesto = 0;
          }
          totalImpuestos += totalImpuesto;
          return {
            descripcionFactura: valueImpuesto.descripcionFactura,
            totalImpuestos: totalImpuesto,
          };
        }
      );
      arrayValue[key].impuestos = totalImpuestos;
      arrayValue[key].arrayImpuestos = arrayImpuestos;
      //5
      const total = round2Decimals(arrayValue[key].subtotal + totalImpuestos);
      arrayValue[key].total = total;

      if (proveedorId) {
        //Consultar proveedor

        const proveedor = this.state.todasProveedores.find(
          (valueP) => valueP._id === proveedorId
        );
        //6
        let totalRetenciones = 0;
        let arrayRetenciones = [];

        proveedor.retenciones.map((valueRetencion) => {
          //7
          let totalRetencion;
          if (valueRetencion.tasaCuota === 1) {
            totalRetencion = round6Decimals(
              totalEntrada * (valueRetencion.monto / 100)
            );
          } else if (valueRetencion.tasaCuota === 2) {
            totalRetencion = round6Decimals(
              (totalEntrada + totalRetenciones) * (valueRetencion.monto / 100)
            );
          }
          totalRetenciones += totalRetencion;
          arrayRetenciones.push({
            descripcionFactura: valueRetencion.descripcionFactura,
            totalRetenciones: totalRetencion,
          });
          return null;
        });

        insumo.retenciones.map((valueRetencion) => {
          if (
            (valueRetencion.aplicaCompra === 1 &&
              proveedor.persona === false) ||
            (valueRetencion.aplicaCompra === 2 && proveedor.persona === true) ||
            valueRetencion.aplicaCompra === 3
          ) {
            //7
            let totalRetencion;
            if (valueRetencion.tasaCuota === 1) {
              totalRetencion = round6Decimals(
                totalEntrada * (valueRetencion.monto / 100)
              );
            } else if (valueRetencion.tasaCuota === 2) {
              totalRetencion = round6Decimals(
                (totalEntrada + totalRetenciones) * (valueRetencion.monto / 100)
              );
            }
            totalRetenciones += totalRetencion;
            arrayRetenciones.push({
              descripcionFactura: valueRetencion.descripcionFactura,
              totalRetenciones: totalRetencion,
            });
          }
          return null;
        });
        arrayValue[key].retenciones = totalRetenciones;
        arrayValue[key].arrayRetenciones = arrayRetenciones;
      }
    }
    this.formRef.current.setFieldsValue({
      insumos: arrayValue,
    });
  }

  cerrarFacturasOrdenDeCompra() {
    this.setState({ modalFacturas: false });
  }

  cerrarRecepcionesOrdenDeCompra() {
    this.setState({ modalRecepciones: false });
  }

  /**
   * Una orden sin aprobar solo la puede bajar quien tiene el permiso de aprobar
   * (es quien la va a revisar). Misma regla que el botón de vista previa del
   * listado.
   */
  puedeDescargar() {
    return this.props.permisoAprobarOrdenDeCompra || this.state.aprobada === true;
  }

  async descargarOrdenDeCompra(value) {
    if (!this.puedeDescargar()) {
      return message.warn("La orden de compra aun no esta aprobada");
    }

    try {
      const res = await axios.post(
        "ordenesdecompra/datosPdf",
        { ordenId: value, empresaId: this.props.empresaId, descarga: true },
        { headers: this.props.headersToken }
      );
      const numero =
        (res.data?.respuestaFactura?.dataSat?.Serie || "") +
        "_" +
        (res.data?.respuestaFactura?.dataSat?.Folio || "");

      pdfMake
        .createPdf(ordenCompraPdf(res.data))
        .download(`Orden_De_Compra_${numero}.pdf`);
    } catch (error) {
      console.error("Error al consultar los datos:", error);
      this.setState({ loading: false });
    }
  }

  async descargarExcel() {
    if (!this.puedeDescargar()) {
      return message.warn("La orden de compra aun no esta aprobada");
    }

    this.setState({ descargandoExcel: true });
    await descargarExcelDocumento({
      modulo: "ordenDeCompra",
      id: this.state.id,
      empresaId: this.props.empresaId,
      headersToken: this.props.headersToken,
    });
    this.setState({ descargandoExcel: false });
  }

  verRequisicionModal(id) {
    this.setState({ modalVerRequisicion: true, modalVerRequisicionId: id });
  }

  cerrarModalVerRequisicion() {
    this.setState({ modalVerRequisicion: false, modalVerRequisicionId: null });
  }

  obtenerColorTagRequisicion = (importancia) => {
    switch (importancia) {
      case 3:
        return "red";
      case 2:
        return "orange";
      case 1:
        return "green";
      default:
        return "blue";
    }
  };

  generarPdfSeparar = () => {
    const doc = separacionInsumosPdf({
      orden: this.state.datosOrdenDeCompra,
      insumos: this.formRef.current?.getFieldValue("insumos") || [],
      catalogoInsumos: this.state.todasInsumos,
      requisiciones: this.state.requisicionesAdicionales,
      simple: !!this.props.separacionInsumosSimpleOC,
      porCliente: !!this.props.separacionInsumosPorClienteOC,
      porDia: !!this.props.separacionInsumosPorDiaOC,
    });

    if (!doc) {
      message.info("No hay insumos para imprimir.");
      return;
    }

    pdfMake.createPdf(doc).getBlob((blob) => {
      if (this.state.pdfSepararUrl) URL.revokeObjectURL(this.state.pdfSepararUrl);
      const url = URL.createObjectURL(blob);
      this.setState({ modalPdfSeparar: true, pdfSepararUrl: url });
    });
  };



  cerrarModalPdfSeparar = () => {
    if (this.state.pdfSepararUrl) {
      URL.revokeObjectURL(this.state.pdfSepararUrl);
    }
    this.setState({ modalPdfSeparar: false, pdfSepararUrl: null });
  };


  renderProyectoCard() {
    return (
      <FormItem shouldUpdate noStyle>
        {({ getFieldValue }) => {
          const proyectoId = getFieldValue("proyectoId");
          const proveedorId = getFieldValue("proveedorId");
          if (!proyectoId) return null;
          const proyecto = this.state.todasProyectos?.find((value) => value._id === proyectoId);
          const proveedor = proveedorId ? this.state.todasProveedores?.find((value) => value._id === proveedorId) : null;

          return (
            <Row gutter={[16, 16]}>
              {/* Card Proyecto */}
              <InfoCard
                title="PROYECTO"
                icon={<InfoCircleOutlined />}
                accentColor="#00BFD6"
                compact
                lg={12}
                sections={[
                  {
                    title: "Información General",
                    icon: <InfoCircleOutlined />,
                    iconColor: "#00BFD6",
                    lg: 12,
                    items: [
                      { label: "Nombre", value: proyecto.nombre || "-" },
                      { label: "Descripción", value: proyecto.descripcion || "-" },
                    ],
                  },
                  {
                    title: proyecto.calle ? "Dirección de envío" : "Vehículo",
                    icon: proyecto.calle ? <EnvironmentOutlined /> : <CarOutlined />,
                    iconColor: "#C9DF00",
                    lg: 12,
                    items: proyecto.calle ? [
                      { label: "Calle", value: proyecto.calle },
                      { label: "Número", value: proyecto.numeroCalle || "-" },
                    ] : [
                      { label: "Marca", value: proyecto.marca || "-" },
                      { label: "Modelo", value: proyecto.modelo || "-" },
                      { label: "Placas", value: proyecto.placas || "-" },
                    ],
                  },
                ]}
              />

              {/* Card Proveedor */}
              <InfoCard
                title="PROVEEDOR"
                icon={<UserOutlined />}
                accentColor="#00BFD6"
                compact
                lg={12}
                sections={
                  proveedor ? [
                    {
                      title: "Datos Generales",
                      icon: <UserOutlined />,
                      iconColor: "#FF6A0D",
                      lg: 13,
                      items: [
                        {
                            label: "Nombre",
                            value: proveedor.nombre
                              ? `${proveedor.nombre} ${proveedor.apellidoPaterno} ${proveedor.apellidoMaterno}`
                              : proveedor.razonSocial || "-",
                            bold: true, 
                        },
                        { label: "RFC", value: proveedor.rfc },
                        { label: "Correo", value: proveedor.correo },
                        { label: "Teléfono", value: proveedor.telefono },
                        { label: "Celular", value: proveedor.celular },
                      ],
                    },
                    {
                      title: "Contacto",
                      icon: <PhoneFilled />,
                      iconColor: "#DB2777",
                      lg: 10,
                      items: [
                        { label: "Contacto",          value: proveedor.nombreContacto   || "-" },
                        { label: "Teléfono",        value: proveedor.telefonoContacto || "-" },
                        { label: "Correo",          value: proveedor.correoContacto   || "-" },
                        { label: "Días de crédito", value: proveedor.diasCredito       ?? "-" },
                      ],
                    },
                  ] : [
                    {
                      items: [{ label: null, value: "Sin proveedor seleccionado", color: "#aaa" }],
                    },
                  ]
                }
              />
            </Row>
          );
        }}
      </FormItem>
    );
  }
  getInsumosColumns() {
    return [
      { title: "#", width: "3%" },
      { title: "Clave",  width: "4%" },
      { title: "Insumo",  width: "20%" },
      { title: "Unidad", width: "4%" },
      { title: "Precio Unitario",  width: "7%"  },
      { title: "Precio Unit. c/Imp.",   width: "7%"  },
      { title: "Cant.", width: "6%"  },
      { title: "Req.",  width: "6%"  },
      { title: "F. Entrega", width: "6%" },
      { title: "Fact.", width: "6%"  },
      { title: "Rec.",  width: "6%"  },
      { title: "Descuento", width: "6%"  },
      { title: "Subtotal / Imp. / Total",   width: "16%" },
    ];

  }

  renderInsumoRow({ key, name, fieldKey: _fieldKey, restField, arrayKey }) {
    return (
      <React.Fragment key={key}>
        {/* Fila principal */}
        <tr>
          <td className="td-border">
            <div style={{ fontSize: '14px', textAlign: 'center', color: '#868585' }}>
              {arrayKey + 1}
            </div>
          </td>
          <td
            className="td-border"
            onDoubleClick={() => {
              const insumoId = this.formRef.current.getFieldValue(['insumos', arrayKey, 'insumoId']);
              const insumoSeleccionado = this.state.todasInsumos?.find(
                (insumo) => insumo._id.toString() === insumoId?.toString()
              );
              const idParaDisponibilidad = insumoSeleccionado?.insumoPrincipalId || insumoSeleccionado?._id;
              const proyectoId = this.formRef.current.getFieldValue('proyectoId');
              this.abrirDisponibilidad(idParaDisponibilidad, insumoSeleccionado?.nombre || insumoSeleccionado?.descripcion || '', proyectoId);
            }}
            style={{ cursor: 'pointer' }}
          >
            <FormItem noStyle shouldUpdate>
              {({ getFieldValue }) => {
                const insumoId = getFieldValue(['insumos', arrayKey, 'insumoId']);
                const insumoSeleccionado = this.state.todasInsumos?.find(
                  (insumo) => insumo._id.toString() === insumoId?.toString()
                );
                return (
                  <div style={{ fontSize: '14px', textAlign: 'center', color: '#868585', pointerEvents: 'none' }}>
                    {insumoSeleccionado?.clave || '-'}
                  </div>
                );
              }}
            </FormItem>
          </td>
          <td className="td-border">
            <FormItem {...restField} name={[name, "insumoId"]} required noStyle >
              <SelectItem
                disabled sinBorde autoFocus
                style={{ width: "100%" }}
                placeholder="Insumo"
                onChange={(value) => this.onChangeInsumo(value, arrayKey)}
              >
                {this.state.objetoInsumos}
              </SelectItem>
            </FormItem>
          </td>
          <td className="td-border">
              <FormItem noStyle shouldUpdate>
                {({ getFieldValue }) => {
                  const insumoId = getFieldValue(['insumos', arrayKey, 'insumoId']);
                  const insumoSeleccionado = this.state.todasInsumos?.find(
                    (insumo) => insumo._id.toString() === insumoId?.toString()
                  );
                  return (
                    <div style={{ fontSize: '14px', textAlign: 'center' , color: '#868585'}}>
                      {insumoSeleccionado?.unidad || '-'}
                    </div>
                  );
                }}
              </FormItem>
          </td>
          <td className="td-border">
            <FormItem {...restField} name={[name, "precioUnitario"]} noStyle required>
              <InputNumberItem
                disabled sinBorde placeholder="Precio Unitario"
                onChange={(value) => this.onChangePrecioCantidadDescuento(value, arrayKey)}
                dinero
              />
            </FormItem>
          </td>
          <td className="td-border">
            <FormItem name={[name, "precioUnitarioConImpuestos"]} noStyle required shouldUpdate>
              <InputNumberItem
                sinBorde disabled placeholder="Precio Unitario con Impuestos"
                onChange={(value) => this.onChangePrecioImpuestos(value, arrayKey)}
                dineroDisabled
              />
            </FormItem>
          </td>
          <td className="td-border">
            <FormItem {...restField} name={[name, "cantidad"]} required number noStyle>
              <InputNumberItem
                disabled sinBorde placeholder="Cantidad"
                onChange={(value) => this.onChangePrecioCantidadDescuento(value, arrayKey)}
              />
            </FormItem>
          </td>
          <td className="td-border" style={{ textAlign: "center" }}>
            <FormItem noStyle shouldUpdate>
              {({ getFieldValue }) => {
                const insumos = getFieldValue("insumos");
                const insumo = insumos[arrayKey];
                const origenesRequisicionOC = Array.isArray(insumo?.requisicionesOrigen) && insumo.requisicionesOrigen.length > 0
                  ? insumo.requisicionesOrigen
                  : (insumo?.requisicionId ? [{ requisicionId: insumo.requisicionId, cantidad: insumo?.cantidad }] : []);
                const tagsRequisicionOC = origenesRequisicionOC
                  .map(origen => ({ origen, req: this.state.requisicionesAdicionales?.find((r) => r._id === origen.requisicionId) }))
                  .filter(x => x.req)
                  .map(({ req, origen }) => ({ id: req._id, nombre: req.numero, fechaSolicitud: req.fechaSolicitud, importancia: req.importancia, cantidad: origen.cantidad }));
                if (tagsRequisicionOC.length > 0) {
                  return (
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 4 }}>
                      {tagsRequisicionOC.map(t => (
                        <Tooltip key={t.id} title={"Fecha de solicitud: " + (t.fechaSolicitud ? moment(t.fechaSolicitud).format("DD/MM/YYYY") : "")}>
                          <Tag color={this.obtenerColorTagRequisicion(t.importancia)} onClick={() => this.verRequisicionModal(t.id)}>
                            {"Req. " + t.nombre + (tagsRequisicionOC.length > 1 ? ` (${t.cantidad})` : "")}
                          </Tag>
                        </Tooltip>
                      ))}
                    </div>
                  );
                }
                return null;
              }}
            </FormItem>
          </td>
          <td className="td-border" style={{ textAlign: "center" }}>
            <FormItem noStyle shouldUpdate>
              {({ getFieldValue }) => {
                const fechaEntrega = getFieldValue(['insumos', arrayKey, 'fechaEntrega']);
                return (
                  <div style={{ fontSize: '14px', textAlign: 'center', color: '#868585' }}>
                    {fechaEntrega ? moment(fechaEntrega).format('DD/MM/YYYY') : '-'}
                  </div>
                );
              }}
            </FormItem>
          </td>
          <td className="td-border">
            <FormItem {...restField} name={[name, "recibidoFacturas"]} required number noStyle>
              <InputNumberItem disabled sinBorde placeholder="Facturado" />
            </FormItem>
          </td>
          <td className="td-border">
            <FormItem {...restField} name={[name, "recibido"]} required number noStyle>
              <InputNumberItem disabled sinBorde placeholder="Recibido" />
            </FormItem>
          </td>
          <td className="td-border">
            <FormItem {...restField} name={[name, "descuento"]} required numberCero noStyle initialValue={0}>
              <InputNumberItem
                disabled sinBorde placeholder="Descuento" porcentaje max={100}
                onChange={(value) => this.onChangePrecioCantidadDescuento(value, arrayKey)}
              />
            </FormItem>
          </td>
          <td className="td-border">
            <FormItem noStyle shouldUpdate>
              {({ getFieldValue }) => {
                const subtotal = getFieldValue(['insumos', arrayKey, 'subtotal']) || 0;
                const impuestos = getFieldValue(['insumos', arrayKey, 'impuestos']) || 0;
                const total = getFieldValue(['insumos', arrayKey, 'total']) || 0;
                return (
                  <div className="celda-totales" style={{ fontSize: '12px' }}>
                    <div>{dineroDisabledMask(subtotal)}</div>
                    <div>{dineroDisabledMask(impuestos)}</div>
                    <div className="total-bold">Total: {dineroDisabledMask(total)}</div>
                  </div>
                );
              }}
            </FormItem>
            {/* Campos hidden para mantener los valores en el form */}
            <FormItem {...restField} name={[name, "subtotal"]} hidden>
              <InputNumberItem />
            </FormItem>
            <FormItem {...restField} name={[name, "impuestos"]} hidden>
              <InputNumberItem />
            </FormItem>
            <FormItem {...restField} name={[name, "total"]} hidden>
              <InputNumberItem />
            </FormItem>
          </td>
         
        </tr>

        {/* Fila detalle de insumo */}
        {this.state.mostrarDetalles && (
          <FormItem
            noStyle
            shouldUpdate={(prevValues, currentValues) => {
              const prev = prevValues.insumos?.[arrayKey];
              const curr = currentValues.insumos?.[arrayKey];
              return (
                prev?.cantidad !== curr?.cantidad ||
                prev?.insumoId !== curr?.insumoId ||
                prev?.precioUnitario !== curr?.precioUnitario
              );
            }}
          >
            {({ getFieldValue }) => {
              const insumos = getFieldValue("insumos");
              const insumoData = insumos?.[arrayKey];
              const cantidad = insumoData?.cantidad;
              const insumoId = insumoData?.insumoId;
              const costo = insumoData?.precioUnitario;
              let insumo = null;
              if (insumoId && this.state.todasInsumos) {
                insumo = this.state.todasInsumos.find(
                  (valueInsumos) => valueInsumos._id === insumoId
                );
              }
              if (!insumo) return null;
              return (
                <InsumoDetalleRow
                  insumo={insumo}
                  cantidad={cantidad}
                  costo={costo}
                  colSpans={{ details: 4, projection: 3, filler: 1 }}
                  disabledModal={true}
                />
              );
            }}
          </FormItem>
        )}

        {/* Fila de observaciones */}
        <FormItem
          noStyle
          shouldUpdate={(prev, curr) =>
            prev.insumos?.[arrayKey]?.observaciones !== curr.insumos?.[arrayKey]?.observaciones ||
            prev.insumos?.[arrayKey]?.observacionesXml !== curr.insumos?.[arrayKey]?.observacionesXml
          }
        >
          {({ getFieldValue }) => {
            const arrayValue = getFieldValue("insumos");
            if (arrayValue?.[arrayKey]?.observaciones) {
              return (
                <tr>
                  <td colSpan="11" className="td-border-sin-right">
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "left",
                        alignItems: "left",
                        backgroundColor: arrayValue[arrayKey].observacionesXml ? "#dceeffff" : "white",
                      }}
                    >
                      <div style={{ width: "90%", textAlign: "left", paddingLeft: 20 }}>
                        {String(arrayValue[arrayKey].observaciones)
                          .split(/\r?\n/)
                          .map((line, i) => (
                            <span key={i}>{line}<br /></span>
                          ))}
                      </div>
                    </div>
                  </td>
                </tr>
              );
            }
            return null;
          }}
        </FormItem>
      </React.Fragment>
    );
  }

  getObservacionesConfig() {
    return {
      observaciones: {
        value: this.formRef.current?.getFieldValue("observaciones"),
        onSave: (newValue) => {
          this.formRef.current?.setFieldsValue({ observaciones: newValue });
          this.forceUpdate();
          axios
            .post("ordenesdecompra/editarObservaciones", {
              ordenId: this.state.id,
              empresaId: this.props.empresaId,
              observaciones: newValue,
            })
            .then((res) => {
              if (res.data.success !== 2) message.info("La orden no se editó");
            });
        },
      },
      observaciones2: {
        label: "Observaciones Internas",
        tooltip: "Estas observaciones no se imprimirán.",
        value: this.formRef.current?.getFieldValue("observaciones2"),
        onSave: (newValue) => {
          this.formRef.current?.setFieldsValue({ observaciones2: newValue });
          this.forceUpdate();
          axios
            .post("ordenesdecompra/editarObservaciones2", {
              ordenId: this.state.id,
              empresaId: this.props.empresaId,
              observaciones2: newValue,
            })
            .then((res) => {
              if (res.data.success !== 2) message.info("La venta no se editó");
            });
        },
      },
      checkboxes: [
        {
          name: "imprimirObservaciones",
          label: "Imprimir",
          onChange: (e) => {
            axios
              .post("ordenesdecompra/editarImprimirObservaciones", {
                ordenId: this.state.id,
                empresaId: this.props.empresaId,
                imprimirObservaciones: e.target.checked,
              })
              .then((res) => {
                if (res.data.success !== 2) message.info("La orden no se editó");
              });
          },
        },
      ],
      totales: (
        <table className="table" style={{ marginTop: 0, fontSize: "16px" }}>
          <tbody>
            <tr>
              <th className="th-totales" style={{ width: "50%", fontSize: "16px" }}>Subtotal</th>
              <td className="td-totales-right" style={{ width: "50%", fontSize: "16px" }}>
                {dineroDisabledMask(this.state.subtotal)}
              </td>
            </tr>
          </tbody>
          {this.state.arrayImpuestos.map((valueArray) => (
            <tbody key={valueArray.descripcionFactura}>
              <tr>
                <th className="th-totales" style={{ fontSize: "16px" }}>{valueArray.descripcionFactura}</th>
                <td className="td-totales-right" style={{ fontSize: "16px" }}>{dineroDisabledMask(valueArray.totalImpuestos)}</td>
              </tr>
            </tbody>
          ))}
          <tbody>
            <tr>
              <th className="th-totales" style={{ fontSize: "16px" }}>Total</th>
              <td className="td-totales-right" style={{ fontSize: "16px" }}>
                {dineroDisabledMask(this.state.total)}
              </td>
            </tr>
          </tbody>
          {this.state.arrayRetenciones.map((value, i) => (
            <tbody key={i}>
              <tr>
                <th className="th-totales" style={{ fontSize: "16px" }}>{value.descripcionFactura}</th>
                <td className="td-totales-right" style={{ fontSize: "16px" }}>{dineroDisabledMask(value.totalRetenciones)}</td>
              </tr>
            </tbody>
          ))}
          <tbody>
            <tr>
              <th className="th-totales" style={{ fontSize: "16px" }}>Total a pagar</th>
              <td className="td-totales-right" style={{ fontSize: "16px" }}>
                {dineroDisabledMask(this.state.totalPagar)}
              </td>
            </tr>
          </tbody>
        </table>
      ),
    };
  }

  render() {
    const puedeDescargar = this.puedeDescargar();

    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title={
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <span>
                Ver Orden de Compra{" "}
                {(this.state.serieOrdenCompra
                  ? this.state.serieOrdenCompra + " - "
                  : "") + this.state.numeroOrdenDeCompra}
              </span>
              {this.state.requisicionNumero && (
                <Tag color="orange">
                  Requisición: {this.state.requisicionNumero}
                </Tag>
              )}
            </div>
          }
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={[
            <Space key="extra-actions" align="center">
              <span style={{ fontSize: 14 }}>
                <strong>Fecha:</strong>{" "}
                {moment(this.state.datosOrdenDeCompra?.createdAt).format("LL")}
              </span>

              <ButtonItem
                icon={<PrinterOutlined />}
                onClick={this.generarPdfSeparar}
              >
                Imprimir separación
              </ButtonItem>
            </Space>
          ]}
        />
        <div className="card-background">
          <Spin spinning={this.state.loading}>
            <Form
              ref={this.formRef}
              name="verOrdenDeCompra"
              layout
            >
               <div style={{ padding: '0 16px', marginBottom: 35 }}>
                {this.renderProyectoCard()}
              </div>
              <GeneralFormLayout
                totalesMaxWidth="25%"
                cards={[
                  {
                    title: "Datos Generales",
                    lg: 18,
                    content: (
                      <Row>
                        <Col span={12}>
                          <FormItem label="Proyecto" name="proyectoId" margin required>
                            <SelectItem disabled placeholder="Proyecto">
                              {this.state.objetoProyectos}
                            </SelectItem>
                          </FormItem>
                          <FormItem shouldUpdate noStyle>
                            {({ getFieldValue }) => {
                              const proyectoId = getFieldValue("proyectoId");
                              if (!proyectoId) return null;
                              const proyecto = this.state.todasProyectos?.find(
                                (value) => value._id === proyectoId
                              );
                              if (!proyecto || !proyecto.subProyectos || proyecto.subProyectos?.length === 0) return null;
                              const opciones = proyecto?.subProyectos?.map((value) => (
                                <Option value={value?.subProyectoId?._id} key={value?.subProyectoId?._id}>
                                  {value?.subProyectoId?.codigo + " - " + value?.subProyectoId?.nombre}
                                </Option>
                              ));
                              return (
                                <FormItem label="Subproyecto" name="subProyectoId" margin>
                                  <SelectItem placeholder="Subproyecto" allowClear disabled>
                                    {opciones}
                                  </SelectItem>
                                </FormItem>
                              );
                            }}
                          </FormItem>
                          <FormItem name="destino" label="Destino" max={50} margin pattern>
                            <InputItem placeholder="Domicilio, Ocurre.." disabled />
                          </FormItem>
                          <FormItem name="embarque" label="Embarque" max={50} margin pattern>
                            <InputItem placeholder="Embarque" disabled />
                          </FormItem>
                         
                        </Col>
                        
                        <Col span={12}>
                          <FormItem label="Proveedor" name="proveedorId" margin required>
                            <SelectItem disabled placeholder="Proveedor">
                              {this.state.objetoProveedores}
                            </SelectItem>
                          </FormItem>
                          <FormItem
                              label="Fecha Entrega"
                              name="fechaEntrega"
                              margin
                            >
                              <DatePickerItem disabled placeholder="Fecha de Entrega" />
                        </FormItem>
                          <FormItem label="Cotizacion" name="cotizacionOC" margin>
                            <InputItem disabled placeholder="Cotizacion" />
                          </FormItem>
                           <FormItem pattern name="atencion" label="Atencion a" margin tooltip="Indica a quien dirigir este documento.">
                            <InputItem disabled />
                          </FormItem>
                        </Col>
                      </Row>
                    ),
                  },
                  {
                    title: "Moneda",
                    lg: 6,
                    content: (
                      <>
                        <FormItem
                          required
                          margin
                          name="monedaId"
                          label="Moneda"
                          labelCol={{ span: 8 }}
                          wrapperCol={{ span: 16 }}
                          initialValue="60c7e4396465ad440c41c15a"
                        >
                          <SelectItem
                            disabled
                            onClick={() =>
                              message.info(
                                "Por el momento nomas se pueden realizar ordenes de compra con moneda MXN"
                              )
                            }
                            onChange={(value) => {
                              if (value === "60c7e4396465ad440c41c15a") {
                                this.formRef.current.setFieldsValue({ tipoDeCambio: 1 });
                              }
                            }}
                            placeholder="Moneda"
                          >
                            {this.state.objetoMonedas}
                          </SelectItem>
                        </FormItem>
                        <FormItem noStyle shouldUpdate={(prev, curr) => prev.monedaId !== curr.monedaId}>
                          {({ getFieldValue, setFieldsValue }) => {
                            const monedaId = getFieldValue('monedaId');
                            const esMxn = monedaId === '60c7e4396465ad440c41c15a';
                            if (esMxn && getFieldValue('tipoDeCambio') !== 1) {
                              setTimeout(() => setFieldsValue({ tipoDeCambio: 1 }), 0);
                            }
                            return esMxn ? (
                              <FormItem
                                name="tipoDeCambio"
                                hidden
                                initialValue={1}
                              >
                                <InputNumberItem />
                              </FormItem>
                            ) : (
                              <FormItem
                                required
                                number
                                margin
                                label="T. Cambio"
                                name="tipoDeCambio"
                                type="number"
                                initialValue={1}
                                labelCol={{ span: 8 }}
                                wrapperCol={{ span: 16 }}
                              >
                                <InputNumberItem disabled dinero placeholder="T. Cambio" />
                              </FormItem>
                            );
                          }}
                        </FormItem>
                      </>
                    ),
                  },
                ]}
  
                 tabsConfig={{
                  tabs: [
                    {
                      key: "insumos",
                      label: "Insumos",
                      listName: "insumos",
                      columns: this.getInsumosColumns(),
                      renderRow: this.renderInsumoRow.bind(this),
                      renderHeader: () => (
                        <Row justify="end" style={{ marginBottom: "0px" , marginRight: "15px" }}>
                          <Col>
                            <Space>
                              <Typography.Text style={{ fontSize: "12px", color: "#888"  }}>
                                Mostrar detalles:
                              </Typography.Text>
                              <Switch
                                size="small"
                                checked={this.state.mostrarDetalles}
                                onChange={(checked) =>
                                  this.setState({ mostrarDetalles: checked })
                                }
                              />
                            </Space>
                            <Space>
                              <Typography.Text style={{ fontSize: "12px", color: "#888" }}>
                                Ver como sistema:
                              </Typography.Text>
                              <Switch
                                size="small"
                                checked={this.state.verInsumosComoSistema}
                                onChange={(checked) => {
                                  const insumos = this.state.todasInsumos || [];
                                  this.setState({
                                    verInsumosComoSistema: checked,
                                    objetoInsumos: insumos.map((value) => (
                                      <Option value={value._id} key={value._id}>
                                        {checked
                                          ? (value.stringBuscarSistema || value.stringBuscar || value.nombre || value.descripcion)
                                          : (value.stringBuscar || value.nombre || value.descripcion)}
                                      </Option>
                                    )),
                                  });
                                }}
                              />
                            </Space>
                          </Col>
                        </Row>
                      ),
                    },
                  ],
                }}
                observacionesConfig={this.getObservacionesConfig()}
                actionButtons={
                  <Space>
                    {this.state.estadoFactura !== 0 && this.state.estado !== 0 && (
                      <ButtonItem
                        icon={<BookOutlined />}
                        blanco
                         hotkey="shift+f"
                        onClick={() => this.setState({ modalFacturas: true })}
                      >
                        Facturas
                      </ButtonItem>
                    )}
                    {this.state.estado !== 0 && this.state.estado !== 1 && (
                      <ButtonItem
                        icon={<BookOutlined />}
                        blanco
                        onClick={() => this.setState({ modalRecepciones: true })}
                      >
                        Recepciones
                      </ButtonItem>
                    )}
                    {this.props.permisoVerPolizasEnDocumentos && (
                      <ButtonItem
                        icon={<BookOutlined />}
                        azulMB
                        hotkey="shift+z"
                        onClick={() => this.setState({ modalPolizas: true })}
                      >
                        Ver Pólizas
                      </ButtonItem>
                    )}
                    <Tooltip
                      title={puedeDescargar ? "Descargar" : "La orden aun no esta aprobada"}
                    >
                      <ButtonItem
                        icon={<DownloadOutlined />}
                        negroB
                        hotkey="shift+d"
                        disabled={!puedeDescargar}
                        onClick={() => this.descargarOrdenDeCompra(this.state.id)}
                      >
                        Descargar
                      </ButtonItem>
                    </Tooltip>
                    <Tooltip
                      title={puedeDescargar ? "Descargar Excel" : "La orden aun no esta aprobada"}
                    >
                      <ButtonItem
                        icon={<FileExcelOutlined />}
                        verdeB
                        loading={this.state.descargandoExcel}
                        disabled={!puedeDescargar}
                        onClick={this.descargarExcel.bind(this)}
                      >
                        Descargar Excel
                      </ButtonItem>
                    </Tooltip>
                    <ButtonItem
                      type='primary'
                       hotkey="shift+m"
                      onClick={this.abrirModalCorreo.bind(this)}
                      cyanB
                    >
                      Mandar Correo
                    </ButtonItem>
                    <ButtonItem
                      type='primary'
                      rojoB
                       hotkey="shift+r"
                      onClick={this.atras.bind(this)}
                    >
                      Regresar
                    </ButtonItem>
                  </Space>
                }
              />
            </Form>
          </Spin>
        </div>
        <FacturasOrdenDeCompra
          history={this.props.history}
          visible={this.state.modalFacturas}
          id={this.state.id}
          cerrarFacturasOrdenDeCompra={this.cerrarFacturasOrdenDeCompra.bind(
            this
          )}
        />
        <RecepcionesOrdenDeCompra
          visible={this.state.modalRecepciones}
          id={this.state.id}
          cerrarRecepcionesOrdenDeCompra={this.cerrarRecepcionesOrdenDeCompra.bind(
            this
          )}
        />
        <MandarCorreoOrdenDeCompra
          visible={this.state.modalCorreo}
          cerrarMandarCorreoOrdenDeCompra={this.cerrarModalCorreo.bind(this)}
          id={this.state.id}
        />
        <ModalVerRequisicion
          visible={this.state.modalVerRequisicion}
          requisicionId={this.state.modalVerRequisicionId}
          onClose={this.cerrarModalVerRequisicion.bind(this)}
          cerrarModalVerRequisicion={this.cerrarModalVerRequisicion.bind(this)}
        />
        <ModalItem
          visible={this.state.modalPdfSeparar}
          onCancel={this.cerrarModalPdfSeparar}
          spinning={false}
          title="PDF Separación de Insumos"
          footer={null}
          width="85vw"
          style={{ top: 20 }}
          destroyOnClose
        >
          {this.state.pdfSepararUrl ? (
            <iframe
              title="PDF Separación"
              src={this.state.pdfSepararUrl}
              style={{ width: "100%", height: "80vh", border: "none" }}
            />
          ) : null}
        </ModalItem>
        <DisponibilidadInsumoModal
          visible={this.state.modalDisponibilidadVisible}
          onClose={this.cerrarDisponibilidad}
          insumoId={this.state.insumoSeleccionadoDisponibilidad.id}
          nombreInsumo={this.state.insumoSeleccionadoDisponibilidad.nombre}
          headersToken={this.props.headersToken}
          empresaId={this.props.empresaId}
          proyectoId={this.state.insumoSeleccionadoDisponibilidad.proyectoId}
        />
        <ModalPolizasDocumento
          visible={this.state.modalPolizas}
          tipo="ordenDeCompra"
          documentoId={this.state.id}
          titulo="Pólizas de la Orden de Compra"
          onCancel={() => this.setState({ modalPolizas: false })}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    verComoSistemaOCPorDefecto: state.empresa.verComoSistemaOCPorDefecto,
    separacionInsumosSimpleOC: state.empresa.separacionInsumosSimpleOC,
    separacionInsumosPorClienteOC: state.empresa.separacionInsumosPorClienteOC,
    separacionInsumosPorDiaOC: state.empresa.separacionInsumosPorDiaOC,
    permisoVerPolizasEnDocumentos: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "6a9b57f6e58adfd453dfa5f4")?.activado,
    permisoAprobarOrdenDeCompra: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "6a13c3f22a586012f040fe34")?.activado,
  };
};

export default connect(mapStateToProps)(VerOrdenDeCompra);